module.exports = __webpack_public_path__ + "img/mini-logo-recamsa-white.b33cbf8f.png";